import React, { FunctionComponent, useEffect, useState } from "react";
import { Grid, Typography } from "@material-ui/core";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Box from "@material-ui/core/Box";
import { StoreConfigurationTableList } from "./StoreConfigurationList/StoreConfigurationTableList";
import { StoreConfiguration } from "./StoreConfigurationList/StoreConfiguration";
import { useConfigStyles } from "../configStyles";
import { Helmet } from "react-helmet-async";
import { useStore } from "../../../store";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

export const TabPanel: FunctionComponent<TabPanelProps> = ({
  children,
  value,
  index,
}) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      //   {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
};

type permissionType = {
  permission_id: number;
  is_add: boolean;
  is_edit: boolean;
  is_view: boolean;
  is_delete: boolean;
};

export const StoreConfigurationMaster = () => {
  const classes = useConfigStyles();
  const [value, setValue] = React.useState(0);
  const [editData, setEditData] = useState<object>({});
  const [editFlag, setEditFlag] = useState<boolean>(false);
  const [viewStoreConfigPermission, setViewStoreConfigPermission] = useState<
    boolean
  >(false);
  const [editStoreConfigPermission, setEditStoreConfigPermission] = useState<
    boolean
  >(false);
  const [addStoreConfigPermission, setAddStoreConfigPermission] = useState<
    boolean
  >(false);

  const [storeConfigurations] = useStore("storeConfigurations");
  const [user] = useStore("auth", "user");

  //console.log("user....", user);

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
    setEditFlag(false);
  };

  const goToEdit = (id: number) => {
    const editRow =
      storeConfigurations && storeConfigurations.find((i: any) => i.id === id);
    setEditData(editRow);
    setEditFlag(true);
    setValue(1);
  };

  const goBackToList = () => {
    setValue(0);
    setEditFlag(false);
  };

  useEffect(() => {
    const storeConfigPermission = user.permissions.find(
      (permission: permissionType) => permission.permission_id === 14
    );
    if (user.is_super_admin === true) {
      setAddStoreConfigPermission(true);
      setEditStoreConfigPermission(true);
      setViewStoreConfigPermission(true);
    } else {
      if (storeConfigPermission) {
        if (storeConfigPermission.is_add === true) {
          setAddStoreConfigPermission(true);
        }
        if (storeConfigPermission.is_view === true) {
          setViewStoreConfigPermission(true);
        }
        if (storeConfigPermission.is_edit === true) {
          setEditStoreConfigPermission(true);
        }
        if (storeConfigPermission.is_view === false) {
          setValue(1);
          setViewStoreConfigPermission(false);
        }
        if (
          storeConfigPermission.is_add === false &&
          storeConfigPermission.is_edit === false &&
          storeConfigPermission.is_view === false
        ) {
          setAddStoreConfigPermission(false);
          setEditStoreConfigPermission(false);
          setViewStoreConfigPermission(false);
        }
      }
    }
  });

  return (
    <>
      <Helmet>
        <title>Store configuration</title>
      </Helmet>
      <Grid
        container
        spacing={2}
        direction="row"
        justify="space-between"
        alignItems="center"
      >
        <Grid item xs={12} className={classes.root}>
          <AppBar position="static">
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="simple tabs example"
            >
              <Tab
                label="Store Configurations List"
                style={{ display: viewStoreConfigPermission ? "" : "none" }}
              />
              {editFlag === false ? (
                <Tab
                  label="Add Store Configurations"
                  style={{ display: addStoreConfigPermission ? "" : "none" }}
                />
              ) : (
                <Tab
                  label="Edit Store Configurations"
                  style={{ display: editStoreConfigPermission ? "" : "none" }}
                  disabled
                />
              )}
            </Tabs>
          </AppBar>

          <TabPanel value={value} index={0}>
            <Grid
              container
              spacing={2}
              direction="row"
              justify="space-between"
              alignItems="center"
            >
              {viewStoreConfigPermission ? (
                <Grid item xs={12}>
                  <StoreConfigurationTableList
                    storeConfigurations={storeConfigurations}
                    goToEdit={goToEdit}
                    editStoreConfigPermission={editStoreConfigPermission}
                  />
                </Grid>
              ) : null}
            </Grid>
          </TabPanel>

          <TabPanel value={value} index={1}>
            <StoreConfiguration
              editFlag={editFlag}
              editData={editData}
              goBackToList={goBackToList}
            />
          </TabPanel>
        </Grid>
      </Grid>
    </>
  );
};
